export default "__VITE_ASSET__ivEM4POg__"